export default function StatsSection() {
  const stats = [
    { value: '40+', label: '研究文章' },
    { value: '5', label: '研究维度' },
    { value: '6', label: '核心学者' },
    { value: '12+', label: '国家案例' },
  ];

  return (
    <section className="py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl font-heading font-bold text-primary-600 mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}